import React from 'react';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { digitalGameIconPath, gameIconSources, GameIcon, getGameIconArtworkPath } from '../utils/gameIconArtwork';

/** Resource artwork follows Artwork, independently of map presentation. */
export function ArtworkImage({ src = '', alt = '', style: imageStyle, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) {
  const style = useMonsterTokenStyle();
  const source = getGameIconArtworkPath(src, style);
  // Generated silhouettes must remain whole inside legacy circular token boxes.
  const presentation = source.startsWith('/icons/digital/')
    ? { ...imageStyle, borderRadius: 0, objectFit: 'contain' as const } : imageStyle;
  return <img {...props} alt={alt} src={source} style={presentation} />;
}

/** A stylesheet also reaches dialogs rendered in portals. */
export function ArtworkIconTheme() {
  const style = useMonsterTokenStyle();
  const variables = (Object.keys(gameIconSources) as GameIcon[])
    .filter(icon => gameIconSources[icon].length)
    .map(icon => `--game-icon-${icon}:url("${style === 'Digital' ? digitalGameIconPath(icon) : gameIconSources[icon][0]}")`)
    .join(';');
  const counters = style === 'Digital'
    ? '--game-icon-count-color:#fff;--game-icon-count-shadow:0 1px 2px #000,0 0 3px #000'
    : '';
  return <style data-game-icon-theme={style}>{`:root{${variables};${counters}}`}</style>;
}
